const generateOGAuthorization = () => {
  const signature = JSON.stringify({
    public_id: window.OG.store.getState().merchantId,
    sig_field: window.dsc.ogAuthSignature.customerId,
    ts: window.dsc.ogAuthSignature.timestamp,
    sig: window.dsc.ogAuthSignature.signature,
  })
  return signature
}

async function fetchWrapper(url, options) {
  if (!window.dsc.customerId || window.dsc.customerId === 'null') {
    throw new Error('Customer is not logged in.')
  }

  const response = await fetch(url, options)

  if (response.status > 400 && response.status < 600) {
    throw response
  }

  const parsedResponse = await response.json()
  return parsedResponse
}

export const getOGCustomer = async (customerId) => {
  if (!window.OG || !window.dsc || window.dsc.customerId === 'null') {
    return
  }

  try {
    const response = await fetch(
      `https://restapi.ordergroove.com/customers/${customerId}/`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: generateOGAuthorization(),
        },
      },
    )

    if (response.status === 404) {
      // there is no customer
      return
    }

    if (response.status > 400 && response.status < 600) {
      throw response
    }

    const parsedResponse = await response.json()
    return parsedResponse
  } catch (error) {
    throw error
  }
}

export const getOGUpcomingOrders = async () => {
  if (!window.OG || !window.dsc || window.dsc.customerId === 'null') {
    return
  }

  try {
    return await fetchWrapper(
      'https://restapi.ordergroove.com/orders?status=1',
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: generateOGAuthorization(),
        },
      },
    )
  } catch (error) {
    throw error
  }
}

export const getOGOrder = async (orderId) => {
  if (!window.OG || !window.dsc || window.dsc.customerId === 'null') {
    return
  }

  try {
    return await fetchWrapper(
      `https://restapi.ordergroove.com/items/?order=${orderId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: generateOGAuthorization(),
        },
      },
    )
  } catch (error) {
    throw error
  }
}

export const addItemToNextBox = async (payload) => {
  if (!window.OG || !window.dsc || window.dsc.customerId === 'null') {
    return
  }

  try {
    return await fetchWrapper('https://restapi.ordergroove.com/items/iu/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: generateOGAuthorization(),
      },
      body: JSON.stringify({
        offer: window.dsc.ogOffer,
        quantity: 1,
        ...payload,
      }),
    })
  } catch (error) {
    throw error
  }
}

export const createFromItem = async (payload) => {
  if (!window.OG || !window.dsc || window.dsc.customerId === 'null') {
    return
  }

  try {
    return await fetchWrapper(
      'https://restapi.ordergroove.com/subscriptions/create_from_item/',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: generateOGAuthorization(),
        },
        body: JSON.stringify({
          offer: window.dsc.ogOffer,
          every_period: 3, // enum for month
          ...payload,
        }),
      },
    )
  } catch (error) {
    throw error
  }
}

export const refreshOGAuth = async () => {
  if (!window.OG || !window.dsc || window.dsc.customerId === 'null') {
    return
  }

  const ogAuthUrl = `https://${window.location.hostname}${window.dsc.ogAuth}`
  try {
    const response = await fetch(ogAuthUrl, {
      method: 'GET',
      headers: {
        accept: 'application/json',
      },
    })
    const html = await response.text()
    const parser = new DOMParser()
    const doc = parser.parseFromString(html, 'text/html')
    const main = doc.querySelector('main')
    const ogAuthString = main.innerHTML
    const parsedOGAuthCookie = ogAuthString
      .split('og_auth_begin')[1]
      .split('og_auth_end')[0]
    const parsedJSONOGAuthCookie = JSON.parse(parsedOGAuthCookie.trim())
    window.dsc = window.dsc || {}
    window.dsc.ogAuthSignature = {
      ...parsedJSONOGAuthCookie,
      signature: btoa(parsedJSONOGAuthCookie.signature),
    }
    const ogAuthCookie = Object.values(window.dsc.ogAuthSignature).join('|')
    document.cookie = `og_auth=${ogAuthCookie};path=/`
    return response
  } catch (error) {
    throw error
  }
}
